module.exports = __webpack_public_path__ + "static/event-hub-create-copy-113aaf5824b07f94667c4445051fed5f.png";